import { useId } from 'react';
import type { IteroOrder } from '../../../../../services/iteroBrowse';
import { CARD_CLASS, SECTION_HEADING_CLASS } from '../browserStyles';
import { prepLabel } from '../iteroBrowseFormat';

const SECTION_CARD_CLASS = `${CARD_CLASS} flex flex-col gap-2 px-3.5 py-3`;

export function OrderTeeth({ order }: { order: IteroOrder }) {
    const headingId = useId();
    if (order.preps.length === 0) return null;
    return (
        <section aria-labelledby={headingId} className={SECTION_CARD_CLASS}>
            <h5 id={headingId} className={SECTION_HEADING_CLASS}>
                Teeth
            </h5>
            <ul className="flex flex-wrap gap-1.5">
                {order.preps.map((prep, index) => (
                    <li
                        key={`${prep.adaId ?? 'x'}-${prep.unitTypeId ?? 'x'}-${index}`}
                        className="rounded-full border border-gray-200 bg-gray-50 px-2.5 py-0.5 text-[12px] font-medium text-gray-700"
                    >
                        {prepLabel(prep)}
                    </li>
                ))}
            </ul>
        </section>
    );
}

export function OrderNotes({ notes }: { notes: string | null }) {
    const headingId = useId();
    const text = notes?.trim();
    if (!text) return null;
    return (
        <section aria-labelledby={headingId} className={SECTION_CARD_CLASS}>
            <h5 id={headingId} className={SECTION_HEADING_CLASS}>
                Notes
            </h5>
            <p className="whitespace-pre-line break-words text-[13px] leading-relaxed text-gray-700">
                {text}
            </p>
        </section>
    );
}
